import React from 'react';

export const formatTableDate = (dateStr) => {
  if (!dateStr || dateStr === '—') return '—';
  try {
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return String(dateStr);
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });
  } catch {
    return String(dateStr);
  }
};

export const formatTableValue = (val, limit = 40, setTooltip) => {
  if (!val || val === '—') return '—';
  const str = String(val);
  if (str.length <= limit) return str;
  if (!setTooltip) return `${str.substring(0, limit)}…`;
  return (
    <span
      onMouseMove={(e) => setTooltip({ x: e.clientX, y: e.clientY, content: str })}
      onMouseLeave={() => setTooltip(null)}
      style={{ cursor: 'pointer' }}
    >
      {str.substring(0, limit)}…
    </span>
  );
};
